<template>
  <div id="inputTrans">  		
    <form v-on:submit="formSubmit" class="form-inline my-2 my-lg-0 ">   <!-- 必需写v-on：，不能只写： -->
    	<input type="text" placeholder="请输入需要翻译的内容" v-model="textValue"class='form-control mr-sm-2'>
    	<select v-model="langValue" class="custom-select">
    		<option value="en" >English</option>
    		<option value="ko">Korean</option>
    		<option value="ja">Japanese</option>
    		<option value="fr">French</option>
    	</select>
    	<input type="submit" value= "翻译" class="btn btn-primary">
    </form>	   
  </div>
</template>

<script>
export default {
  name: 'inputTrans',
  data () {
    return {
      textValue:"",
      langValue:"en"
    }
  },
  methods:{
  	formSubmit:function (e) {
  		this.$emit("formSubmit",this.textValue,this.langValue)   //子组件向父组件传递内容：$emit("任意取名","参数")
  		e.preventDefault();
  	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#inputTrans{
		width: 400px;
		margin: auto;
		margin-bottom: 50px;
	}
	.btn{
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/InputTrans.vue